import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import axios from "axios";
import Layout from "../../../layout/Layout";
import {
  config,
  manageCompaniesAPI,
  poDateAPI,
  purchaseOrderAPI,
  materialReceiptAPI,
} from "../../../config";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";

import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import { MaterialReactTable } from "material-react-table";
import { customHistory } from "../../../history";

function PurchaseOrderList() {
  const navigate = useNavigate();
  const filterData = JSON.parse(localStorage.getItem("filterData") || "{}");

  const [totalCount, setTotalCount] = useState(0);
  const [clientMasterList, setClientMasterList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderType, setOrderType] = useState(filterData.orderType || 0);
  const [pageIndex, setPageIndex] = useState(filterData.pageIndex || 0);
  const [pageSize, setPageSize] = useState(filterData.pageSize || 10);
  const [filters, setFilters] = useState(filterData.columnFilters || []);
  const [sorting, setSorting] = useState([]);
  const [showColumnFilters, setShowColumnFilters] = useState(true);
  const [initialized, setInitialized] = useState(false);

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [pendingUpdate, setPendingUpdate] = useState(null);
  const [rowValues, setRowValues] = useState({}); // To track local changes before confirm

  useEffect(() => {
    setPageIndex(filterData.pageIndex ?? 0);
    setPageSize(filterData.pageSize ?? 10);
    setInitialized(true);
  }, [filterData.pageIndex, filterData.pageSize]);

  const getFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // Months are 0-indexed

    // If current month is Jan-Mar, financial year started last year
    const startYear = month >= 4 ? year : year - 1;
    const endYear = startYear + 1;

    return `${startYear}-${endYear}`;
  };
  const [PoDate, setPoDate] = useState(filterData.PoDate || getFinancialYear());
  const [poDateList, setPoDateList] = useState([]); // to store dropdown data
  const [companyName, setCompanyName] = useState(filterData.companyName ?? 0);
  const [companyNames, setCompanyNames] = React.useState([]);
  const [searchString, setSearchString] = useState(filterData.searchString || "");
  const poTypeList = [
    { label: "All", value: 0 },
    { label: "Purchase Order", value: 1 },
    { label: "Work Order", value: 2 },
  ];

  function filterStorage() {
    localStorage.setItem(
      "filterData",
      JSON.stringify({
        orderType: orderType,
        PoDate: PoDate,
        companyName: companyName,
        searchString: searchString,
        pageIndex: pageIndex,
        pageSize: pageSize,
        columnFilters: filters,
      }),
    );
  }

  initialized && filterStorage();

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (Object.keys(rowValues).length > 0) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    const unblock = customHistory.block((tx) => {
      if (Object.keys(rowValues).length > 0) {
        if (
          window.confirm(
            "Are you sure you want to exit this page? Your entered data will be refreshed and you will have to enter it again.",
          )
        ) {
          unblock();
          tx.retry();
        }
      } else {
        unblock();
        tx.retry();
      }
    });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      unblock();
    };
  }, [rowValues]);

  let tempRefs = useRef(false);
  const userData = JSON.parse(localStorage.getItem("user") || "{}");

  useEffect(() => {
    if (!tempRefs.current) {
      const config = {
        method: "POST",
        url: poDateAPI,
        headers: {
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then((response) => {
          const { minYear, maxYear } = response.data.result;

          const financialYears = [];
          for (let year = minYear; year <= maxYear; year++) {
            const nextYear = year + 1;
            const label = `${year}-${nextYear}`;
            financialYears.push({ value: label, label });
          }

          setPoDateList(financialYears);
        })
        .catch((error) => {
          console.error("Error fetching PO date:", error);
        });

      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  async function clearSearch() {
    localStorage.removeItem("filterData");
    setOrderType(0);
    setPoDate(getFinancialYear());
    setCompanyName(0);
    setSearchString("");
    setFilters([]);
    fetchPO();
    setPageIndex(0);
    setPageSize(10);
  }
  // getting all companies
  useEffect(() => {
    if (tempRefs.current === false) {
      const data = {
        intType: 5,
      };

      axios({
        method: "POST",
        url: manageCompaniesAPI,
        headers: config.headers,
        data: JSON.stringify(data),
      })
        .then(function (response) {
          const allOption = { id: 0, company_name: "All" };
          const updatedCompanyList = [allOption, ...response.data.result];
          setCompanyNames(updatedCompanyList);
        })
        .catch(function (error) {
          console.log(error);
        });
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  const [kpiTotals, setKpiTotals] = useState({ poCount: 0, woCount: 0, totalVal: 0 });

  const fetchPOTotals = useCallback(async () => {
    const data = JSON.stringify({
      txtOrderType: orderType,
      txtPODate: PoDate,
      txtCompanyName: companyName,
      txtSearchString: searchString,
      txtSortDirection: "desc",
      sorting,
      columnFilters: filters,
      intLimit: 100000,
      intOffset: 0,
      intType: 23,
    });

    axios({
      method: "POST",
      url: purchaseOrderAPI,
      headers: config.headers,
      data,
    })
      .then(function (response) {
        const records = response.data.data || [];
        let poCount = 0;
        let woCount = 0;
        let totalVal = 0;
        records.forEach(row => {
          if (row.status !== 100) { // Don't count cancelled orders
            if (Number(row.order_type) === 1) poCount++;
            if (Number(row.order_type) === 2) woCount++;
            totalVal += Number(row.total_with_gst || 0);
          }
        });
        setKpiTotals({ poCount, woCount, totalVal });
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [orderType, PoDate, companyName, searchString, sorting, filters]);

  const fetchPO = useCallback(async () => {
    setLoading(true);
    setClientMasterList([]);

    const data = JSON.stringify({
      txtOrderType: orderType,
      txtPODate: PoDate,
      txtCompanyName: companyName,
      txtSearchString: searchString,
      txtSortDirection: "desc",
      sorting,
      columnFilters: filters,
      intLimit: pageSize,
      intOffset: pageIndex * pageSize,
      intType: 23,
    });

    axios({
      method: "POST",
      url: purchaseOrderAPI,
      headers: config.headers,
      data,
    })
      .then(function (response) {
        setClientMasterList(response.data.data);
        setTotalCount(response.data.total_count);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false); // Set loading to false in case of error
      });
  }, [
    orderType,
    PoDate,
    companyName,
    searchString,
    sorting,
    filters,
    pageSize,
    pageIndex,
  ]);

  useEffect(() => {
    fetchPO();
    fetchPOTotals();
  }, [
    pageIndex,
    pageSize,
    sorting,
    filters,
    PoDate,
    orderType,
    companyName,
    searchString,
    fetchPO,
    fetchPOTotals,
  ]);

  const handleEditRole = useCallback(
    (id) => {
      navigate(`/purchase-order/view/${id}`);
    },
    [navigate],
  );

  const handleEditPO = useCallback(
     (id) => {
       navigate(`/purchase-order/edit/${id}`);
     },
     [navigate],
   );

  const handleGenerateProforma = useCallback(
    (id) => {
      setLoading(true);
      axios({
        method: "POST",
        url: `${materialReceiptAPI}/create-from-po`,
        data: {
          poId: id,
          createdBy: userData.id,
        },
      })
        .then((res) => {
          alert(res.data.message);
          navigate("/material-receipt/list");
        })
        .catch((err) => {
          alert(err.response?.data?.message || "Failed to generate Material Receipt");
        })
        .finally(() => setLoading(false));
    },
    [navigate, userData.id],
  );

  const handleInputChange = (rowId, field, value) => {
    setRowValues((prev) => ({
      ...prev,
      [rowId]: {
        ...prev[rowId],
        [field]: value,
      },
    }));
  };

  const handleUpdateClick = useCallback(
    (row) => {
      const updatedData = {
        ...row.original,
        ...(rowValues[row.original.id] || {}),
      };
      setPendingUpdate(updatedData);
      setIsUpdateModalOpen(true);
    },
    [rowValues],
  );

  const confirmUpdate = async () => {
    if (!pendingUpdate) return;

    const data = {
      ...pendingUpdate,
      intType: 24,
    };

    config.method = "POST";
    config.data = JSON.stringify(data);
    config.url = purchaseOrderAPI;

    try {
      const response = await axios(config);
      if (response.data.success) {
        setIsUpdateModalOpen(false);
        setPendingUpdate(null);
        setRowValues((prev) => {
          const newValues = { ...prev };
          delete newValues[pendingUpdate.id];
          return newValues;
        });
        fetchPO();
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  };

  const handleCancelPO = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to cancel this Purchase Order?"
    );
    if (!isConfirmed) return;

    const data = {
      intType: 7,
      intStatus: 100,
      intPOId: id,
    };

    const token = userData?.token || "";
    
    try {
      const response = await axios({
        method: "POST",
        url: purchaseOrderAPI,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        data: JSON.stringify(data),
      });

      if (response.data.success || response.data.code === 0) {
        fetchPO();
      }
    } catch (error) {
      console.error("Cancel failed:", error);
    }
  };

  function findType(invoiceType) {
    if (Number(invoiceType) === 1) {
      return "Purchase Order";
    } else if (Number(invoiceType) === 2) {
      return "Work Order";
    }
  }

  function roundUpToInteger(value) {
    // Round up to the nearest integer
    const roundedValue = Math.ceil(value);

    // Append ".00" to the rounded value
    const formattedValue = roundedValue.toFixed(2);

    return formattedValue;
  }

  const columns = useMemo(
    () => [
      {
        accessorKey: "po_no",
        header: "PO No",
        size: 150,
        Cell: ({ row }) => (
          <span
            style={{
              color: "#1976d2",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => handleEditPO(row.original.id)}
          >
            {row.original.po_no}
          </span>
        ),
        enableColumnFilter: true,
      },
      {
        accessorKey: "po_date",
        header: "PO Date",
        size: 100,
        enableColumnFilter: true,

        Cell: ({ cell }) =>
          cell.getValue() ? moment(cell.getValue()).format("DD-MM-YYYY") : "-",
      },
      {
        header: "View",
        size: 80,
        enableColumnFilter: false,

        Cell: ({ row }) => (
          <IconButton
            color="success"
            onClick={() => handleEditRole(row.original.id)}
          >
            <VisibilityIcon />
          </IconButton>
        ),
      },
      {
        accessorKey: "description_of_goods",
        header: "Description of Goods",
        size: 300,
        enableColumnFilter: true,
        Cell: ({ cell }) => {
          const val = cell.getValue();
          if (!val) return "-";
          const items = val.split(", ");
          return (
            <Box
              sx={{
                maxHeight: "120px",
                overflowY: "auto",
                textAlign: "left",
                fontSize: "0.85rem",
                padding: "4px",
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#ccc",
                  borderRadius: "4px",
                },
              }}
            >
              <ul style={{ margin: 0, paddingLeft: "16px", listStyleType: "disc" }}>
                {items.map((item, index) => (
                  <li key={index} style={{ marginBottom: "2px" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </Box>
          );
        },
      },
      {
        accessorKey: "order_type",
        header: "Order Type",
        size: 120,
        enableColumnFilter: false,

        Cell: ({ cell }) => <span>{findType(cell.getValue())}</span>,
      },
      {
        accessorKey: "vendor_name",
        header: "Vendor Name",
        size: 200,
        enableColumnFilter: true,
      },
      {
        accessorKey: "company_Name",
        header: "Company Name",
        size: 150,
        enableColumnFilter: true,
        enableSorting: false,
      },
      {
        accessorKey: "project_name",
        header: "Project Name",
        size: 250,
        enableColumnFilter: true,
      },
      {
        accessorKey: "po_validate_upto",
        header: "PO Valid Upto",
        size: 120,
        enableColumnFilter: false,

        Cell: ({ cell }) =>
          cell.getValue() ? moment(cell.getValue()).format("DD-MM-YYYY") : "-",
      },
      {
        accessorKey: "total_with_gst",
        header: "Amount (Rs.)",
        size: 120,
        enableColumnFilter: true,

        Cell: ({ cell }) => roundUpToInteger(cell.getValue()),
      },
      {
        accessorKey: "invoice_date",
        header: "Invoice Date",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="date"
            value={
              rowValues[row.original.id]?.invoice_date !== undefined
                ? rowValues[row.original.id].invoice_date
                : row.original.invoice_date
                  ? moment(row.original.invoice_date).format("YYYY-MM-DD")
                  : ""
            }
            onChange={(e) =>
              handleInputChange(row.original.id, "invoice_date", e.target.value)
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "invoice_no",
        header: "Invoice Number",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            value={
              rowValues[row.original.id]?.invoice_no !== undefined
                ? rowValues[row.original.id].invoice_no
                : row.original.invoice_no || ""
            }
            onChange={(e) =>
              handleInputChange(row.original.id, "invoice_no", e.target.value)
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "invoice_value",
        header: "Invoice Value",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="number"
            value={
              rowValues[row.original.id]?.invoice_value !== undefined
                ? rowValues[row.original.id].invoice_value
                : row.original.invoice_value || ""
            }
            onChange={(e) =>
              handleInputChange(
                row.original.id,
                "invoice_value",
                e.target.value,
              )
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "advance_payment",
        header: "Advance Payment",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="number"
            value={
              rowValues[row.original.id]?.advance_payment !== undefined
                ? rowValues[row.original.id].advance_payment
                : row.original.advance_payment || ""
            }
            onChange={(e) =>
              handleInputChange(
                row.original.id,
                "advance_payment",
                e.target.value,
              )
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "advance_payment_date",
        header: "Advance Payment Date",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="date"
            value={
              rowValues[row.original.id]?.advance_payment_date !== undefined
                ? rowValues[row.original.id].advance_payment_date
                : row.original.advance_payment_date
                  ? moment(row.original.advance_payment_date).format(
                      "YYYY-MM-DD",
                    )
                  : ""
            }
            onChange={(e) =>
              handleInputChange(
                row.original.id,
                "advance_payment_date",
                e.target.value,
              )
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "final_payment",
        header: "Final Payment",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="number"
            value={
              rowValues[row.original.id]?.final_payment !== undefined
                ? rowValues[row.original.id].final_payment
                : row.original.final_payment || ""
            }
            onChange={(e) =>
              handleInputChange(
                row.original.id,
                "final_payment",
                e.target.value,
              )
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "final_payment_date",
        header: "Final Payment Date",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            type="date"
            value={
              rowValues[row.original.id]?.final_payment_date !== undefined
                ? rowValues[row.original.id].final_payment_date
                : row.original.final_payment_date
                  ? moment(row.original.final_payment_date).format("YYYY-MM-DD")
                  : ""
            }
            onChange={(e) =>
              handleInputChange(
                row.original.id,
                "final_payment_date",
                e.target.value,
              )
            }
            size="small"
          />
        ),
      },
      {
        accessorKey: "payment_mode",
        header: "Payment Mode",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <TextField
            value={
              rowValues[row.original.id]?.payment_mode !== undefined
                ? rowValues[row.original.id].payment_mode
                : row.original.payment_mode || ""
            }
            onChange={(e) =>
              handleInputChange(row.original.id, "payment_mode", e.target.value)
            }
            size="small"
          />
        ),
      },
      {
        header: "Action",
        size: 150,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "8px" }}>
            {row.original.status === 100 ? (
              <Typography color="error" fontWeight="bold">
                Cancelled
              </Typography>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleUpdateClick(row)}
                >
                  Save
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => handleGenerateProforma(row.original.id)}
                >
                  Material Receipt
                </Button>
                {(userData?.position === 11 || userData?.position === 17) && (
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleCancelPO(row.original.id)}
                  >
                    Cancel
                  </Button>
                )}
              </>
            )}
          </div>
        ),
      },
    ],
    [rowValues, handleEditPO, handleEditRole, handleUpdateClick, handleCancelPO, handleGenerateProforma, userData],
  );

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Purchase Order List
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Purchase Order</Typography>
              <Typography color="text.primary">List</Typography>
            </Breadcrumbs>
          </Grid>

          <Grid item xs={6}>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <LoadingButton
                  size="medium"
                  variant="contained"
                  color="success"
                  className="button_first"
                  href="/purchase-order/create"
                  startIcon={<AddIcon />}
                >
                  Add PO
                </LoadingButton>
              </Grid>
              <Grid item>
                <LoadingButton
                  size="medium"
                  variant="contained"
                  color="primary"
                  onClick={() => navigate(-1)}
                  startIcon={<ArrowBackIosIcon />}
                >
                  Back
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={3} mt={2}>
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                select
                label="Order Type"
                value={orderType}
                onChange={(e) => {
                  setOrderType(e.target.value);
                }}
              >
                {poTypeList.map((row, index) => (
                  <MenuItem value={row.value} key={index}>
                    {row.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                select
                label="Financial Year"
                value={PoDate}
                onChange={(e) => {
                  setPoDate(e.target.value);
                }}
              >
                {poDateList.map((row, index) => (
                  <MenuItem value={row.value} key={index}>
                    {row.label}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4}>
            <FormControl fullWidth>
              <TextField
                select
                label="Company Name"
                value={companyName}
                onChange={(e) => {
                  setCompanyName(e.target.value);
                }}
              >
                {companyNames.map((row, index) => (
                  <MenuItem value={row.id} key={index}>
                    {row.company_name}
                  </MenuItem>
                ))}
              </TextField>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} sm={6} md={6} lg={3} alignItems={`center`}>
            <LoadingButton
              size="large"
              variant="contained"
              color="primary"
              onClick={() => {
                tempRefs.current = false; 
                fetchPO(1);
              }}
            >
              Search
            </LoadingButton>
          </Grid>
           */}

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              id="myTextField"
              label="Search"
              onChange={(e) => setSearchString(e.target.value)}
              value={searchString}
              variant="outlined"
              margin="normal"
              placeholder="Search"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "40px",
                  paddingLeft: "20px", // Adjust the padding if necessary
                },
                "& .MuiInputBase-input": {
                  textAlign: "center", // Center the placeholder text
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Button
              style={{
                marginTop: 18,
                color: "white",
                backgroundColor: "red",
                marginLeft: "20px",
                padding: "10px",
              }}
              onClick={() => clearSearch()}
            >
              Clear
            </Button>
          </Grid>
        </Grid>

         <Grid container spacing={3} mt={1} mb={1}>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #1976d2",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                Total Purchase Orders
              </Typography>
              <Typography variant="h4" color="primary.main" fontWeight={700} mt={1}>
                {kpiTotals.poCount}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                background: "linear-gradient(135deg, #ede7f6 0%, #d1c4e9 100%)",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #673ab7",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                Total Work Orders
              </Typography>
              <Typography variant="h4" color="secondary.main" fontWeight={700} mt={1}>
                {kpiTotals.woCount}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                padding: "20px",
                borderRadius: "12px",
                textAlign: "center",
                background: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                borderLeft: "6px solid #2e7d32",
              }}
            >
              <Typography variant="subtitle2" color="text.secondary" fontWeight={600}>
                Total Order Value
              </Typography>
              <Typography variant="h4" sx={{ color: "#2e7d32" }} fontWeight={700} mt={1}>
                {new Intl.NumberFormat("en-IN", {
                  style: "currency",
                  currency: "INR",
                  maximumFractionDigits: 0,
                }).format(kpiTotals.totalVal)}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <MaterialReactTable
          columns={columns}
          data={clientMasterList}
          enableGlobalFilter={false}
          enableFullScreenToggle={false}
          enableColumnFilters={true}
          enableDensityToggle={false}
          className="mat-react-tbl"
          state={{
            isLoading: loading,
            pagination: { pageIndex, pageSize },
            sorting,
            columnFilters: filters,
            showColumnFilters,
          }}
          onShowColumnFiltersChange={setShowColumnFilters}
          manualPagination
          manualSorting
          manualFiltering
          rowCount={totalCount}
          onPaginationChange={(updater) => {
            if (!initialized) return;

            const result =
              typeof updater === "function"
                ? updater({ pageIndex, pageSize })
                : updater;

            setPageIndex(result.pageIndex);
            setPageSize(result.pageSize);
          }}
          onSortingChange={setSorting}
          onColumnFiltersChange={setFilters}
          muiTableBodyCellProps={{
            sx: {
              padding: "3px 8px",
              border: "1px solid #ccc",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              "& input": {
                color: "#fff !important",
                "&::placeholder": {
                  color: "#fff !important",
                  opacity: 1,
                },
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // selected text color
              },
              "& .MuiSelect-icon": {
                color: "#fff !important", // dropdown arrow color
              },
              color: "#fff",
              fontWeight: "bold",
              "& svg": {
                color: "#fff",
              },
              "& .MuiTableSortLabel-root": {
                color: "#495057",
                "&.Mui-active": {
                  color: "#fff",
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#fff !important",
              },
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              borderBottom: "1px solid #ccc",
              backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#e3f2fd",
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              "& input": {
                color: "#fff !important", // Change text color
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#fff !important", // Change underline color
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "#fff !important", // Hover underline color
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#fff !important", // Focused underline color
              },
            },
          }}
        />

        <Dialog
          open={isUpdateModalOpen}
          onClose={() => setIsUpdateModalOpen(false)}
        >
          <DialogTitle>Confirm Update</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to update the new changes?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setIsUpdateModalOpen(false)}
              color="secondary"
            >
              Cancel
            </Button>
            <Button onClick={confirmUpdate} color="primary" variant="contained">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </Layout>
  );
}

export default PurchaseOrderList;
